import gql from "graphql-tag";

export const FORWARD_CLIENT_LOG = gql`
  mutation ForwardClientLog($level: ClientLogLevel!, $message: String!) {
    forwardClientLog(level: $level, message: $message)
  }
`;

export function maskKey(key?: string) {
  if (!key) return "(empty)";
  if (key.length <= 3) return "***";
  return `${key.slice(0, 3)}***`;
}

export function buildClientLogMessage(
  level: "LOG" | "ERROR",
  id: string,
  action: string,
  creds: string,
  detail = ""
) {
  return `${id} - ${level} - website - Google -  - ${action} - ${window.location.hostname} ${creds} - ${detail}`;
}

export function sendClientLog(
  mutate: (vars: { level: string; message: string }) => Promise<unknown>,
  level: "LOG" | "ERROR",
  id: string,
  action: string,
  creds: string,
  detail = ""
) {
  mutate({
    level,
    message: buildClientLogMessage(level, id, action, creds, detail),
  }).catch(() => {});
}

export function buildLoadbalancerLogMessage(
  level: "LOG" | "ERROR",
  id: "loadbalancer_4xx" | "loadbalancer_5xx",
  statusCode: number
) {
  const domain = window.location.hostname;
  const url = window.location.href;
  const errorLabel = `Error ${statusCode}`;
  return `${id} - ${level} - loadbalancer - Cloudflare -  - HTTP ${statusCode} - ${domain}  - ${url} - ${errorLabel}`;
}

export function sendLoadbalancerLog(
  mutate: (vars: { level: string; message: string }) => Promise<unknown>,
  statusCode: number
) {
  if (typeof window === "undefined") return;
  if (statusCode < 400 || statusCode >= 600) return;

  const is5xx = statusCode >= 500;
  const level = is5xx ? "ERROR" : "LOG";
  const id = is5xx ? "loadbalancer_5xx" : "loadbalancer_4xx";

  mutate({
    level,
    message: buildLoadbalancerLogMessage(level, id, statusCode),
  }).catch(() => {});
}
